import React, { useState, forwardRef, useRef, useEffect, useImperativeHandle} from 'react';
import { SliderComponent } from '@syncfusion/ej2-react-inputs';
import {AMModal} from '../../../ApiCenter/API_GET'
import './ManageLengths.css'


export const ManageLengths = forwardRef((props, ref) => {
    const defaultSettings = {
        showModal: false,
    }

    const constraintsArray = props.constraints // TC array, not used but in case is here

    const [modalSettings, setModalSettings] = useState(defaultSettings)
    const [selectedOption, setSelectedOption] = useState('script') // Stato per gestire la selezione

    const [toleranceUnit, setToleranceUnit] = useState('percentage') // 'percentage' or 'seconds'
    const [tolerance, setTolerance] = useState([-5, 5]) // [negative, positive]
    
    const [independentDuration, setIndependentDuration] = useState([500, 5000]) // [min, max] in milliseconds

    const [buttonText, setButtonText] = useState('Script');
    const [buttonClass, setButtonClass] = useState('btn-primary');

    const infoRef = useRef(null);

    useImperativeHandle(ref, () => ({
        openModal(props) {

            let validInfo = true

            if(!props || !props.rowData.duration_settings){
                validInfo = false
            }

            infoRef.current = props.rowData
            const settings = props.rowData.duration_settings
            
            setSelectedOption(validInfo ? settings.comparisonMode : 'script');
            setTolerance(validInfo ? [settings.tolerance.negative, settings.tolerance.positive] : [-5, 5]);
            setToleranceUnit(validInfo ? settings.tolerance.unit : 'percentage');
            setIndependentDuration(validInfo ? [settings.durationCheck.minDuration * 1000, settings.durationCheck.maxDuration * 1000] : [500, 5000]);
            setModalSettings({ showModal: true });
        }
    }));

    useEffect(() => {
        let text = 'Script';
        let className = 'btn-primary';

        if (selectedOption === 'script') {
            text = 'Script';
            className = 'btn-primary';
        } else if (selectedOption === 'column') {
            text = 'Column';
            className = 'btn-danger';
        } else if (selectedOption === 'custom') {
            const toleranceText = `(${tolerance[0]}/${tolerance[1]}${toleranceUnit === 'percentage' ? '%' : 's.'})`;
            text = `Custom ${toleranceText}`;
            className = 'btn-danger';
        } else if (selectedOption === 'rangeDuration') {
            const min = independentDuration[0] / 1000;
            const max = independentDuration[1] / 1000;
            text = `Times (${min}-${max}s)`;
            className = 'btn-danger';
        }

        setButtonText(text);
        setButtonClass(className);

    }, [selectedOption, toleranceUnit, tolerance, independentDuration, constraintsArray]);




    const handleToleranceSave = (newValue, which) => {
        const numValue = parseFloat(newValue);
        if (isNaN(numValue)) return;

        let [min, max] = tolerance;
        const unitLimit = toleranceUnit === 'percentage' ? 50 : 30;

        if (which === 'negative') {
            let newMin = numValue;
            if (newMin > 0) newMin = 0;
            if (newMin < -unitLimit) newMin = -unitLimit;
            min = newMin;
        } else { // positive
            let newMax = numValue;
            if (newMax < 0) newMax = 0;
            if (newMax > unitLimit) newMax = unitLimit;
            max = newMax;
        }
        setTolerance([min, max]);
    };

    const handleDurationSave = (newValue, which) => {
        const numValue = parseFloat(newValue);
        if (isNaN(numValue)) return;

        let [min, max] = independentDuration;

        if (which === 'min') {
            let newMin = numValue * 1000;
            if (newMin < 500) newMin = 500;
            if (newMin > max) newMin = max;
            min = newMin;
        } else { // max
            let newMax = numValue * 1000;
            if (newMax > 60000) newMax = 60000;
            if (newMax < min) newMax = min;
            max = newMax;
        }
        setIndependentDuration([min, max]);
    };

    const applyData = () => {
        const settings = {
            comparisonMode: selectedOption, // 'script', 'column', 'custom', 'rangeDuration'
            
            // The parent component expects a 'customConstraint' object when in custom mode.
            customConstraint: selectedOption === 'custom' ? {
                tollerance_negative: tolerance[0],
                tollerance_positive: tolerance[1]
            } : null,
            
            // The parent component also checks a separate 'tolerance' object.
            tolerance: {
                enabled: selectedOption === 'custom',
                unit: toleranceUnit,
                negative: tolerance[0],
                positive: tolerance[1]
            },

            // Independent duration check is enabled only if 'rangeDuration' is selected
            durationCheck: {
                enabled: selectedOption === 'rangeDuration',
                minDuration: independentDuration[0] / 1000, 
                maxDuration: independentDuration[1] / 1000
            },
            reference: infoRef.current
        };
        props.onApplyCustomLengths(settings);
        setModalSettings({ showModal: false });
    }

    return <>
        {props.showButton &&<button style={{marginLeft: '10px'}} className={`btn btn-sm ${buttonClass}`} onClick={() => setModalSettings({showModal: true})}>{buttonText}</button>}
        {modalSettings.showModal && <AMModal
            settings={modalSettings}
            setSettings={setModalSettings}
            header_title="Manage Duration"
            size="lg"
            closeHandler={() => setModalSettings({showModal: false})}
            buttons={<button style={{width: 100}} className="btn btn-primary btn-sm" onClick={applyData}>Apply</button>}
            
        >   <div>
                <h5 className={`mb-1`}>Constraint Comparison</h5>
                <div className={`mb-2`}><small>Select a reference source: the original script's TC or a custom TC.</small></div>
                
                <div className="row justify-content-center g-1">
                    {/* Pannel Script */}
                    <div className="col-3 mb-0">
                        <div 
                            className={`card selecion-comparation ${selectedOption === 'script' ? '' : 'opacity-50'} mb-1`}
                            style={{ 
                                border: selectedOption === 'script' ? '2px solid #0d6efd' : '2px solid transparent',
                            }}
                            onClick={() => setSelectedOption('script')}
                        >
                            <div className="card-body text-center p-2">
                                <div className="form-check d-flex justify-content-center mb-1">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="constraintOption" 
                                        id="scriptOption" 
                                        value="script" 
                                        checked={selectedOption === 'script'}
                                        onChange={(e) => setSelectedOption(e.target.value)}
                                    />
                                </div>
                                <h6 className="card-title mb-1 p-0">Script</h6>
                                <p className="duration-card-selection card-text text-muted small mb-0">Use Script TCs</p>
                            </div>
                        </div>
                    </div>

                    {/* Pannel Column */}
                    <div className="col-3">
                        <div 
                            className={`card selecion-comparation ${selectedOption === 'column' ? '' : 'opacity-50'} mb-1`}
                            style={{ 
                                border: selectedOption === 'column' ? '2px solid #0d6efd' : '2px solid transparent',
                            }}
                            onClick={() => setSelectedOption('column')}
                        >
                            <div className="card-body text-center p-2 d-flex flex-column justify-content-center">
                                <div className="form-check d-flex justify-content-center mb-1">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="constraintOption" 
                                        id="columnOption" 
                                        value="column" 
                                        checked={selectedOption === 'column'}
                                        onChange={(e) => setSelectedOption(e.target.value)}
                                    />
                                </div>
                                <h6 className="card-title mb-1 p-0">Column</h6>
                                <p className="duration-card-selection card-text text-muted small mb-0">Source Length Column</p>
                            </div>
                        </div>
                    </div>

                    {/* Pannel Custom */}
                    <div className="col-3">
                        <div 
                            className={`card selecion-comparation ${selectedOption === 'custom' ? '' : 'opacity-50'} mb-1`}
                            style={{ 
                                border: selectedOption === 'custom' ? '2px solid #0d6efd' : '2px solid transparent',
                            }}
                            onClick={() => setSelectedOption('custom')}
                        >
                            <div className="card-body text-center p-2 d-flex flex-column justify-content-center">
                                <div className="form-check d-flex justify-content-center mb-1">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="constraintOption" 
                                        id="customOption" 
                                        value="custom" 
                                        checked={selectedOption === 'custom'}
                                        onChange={(e) => setSelectedOption(e.target.value)}
                                    />
                                </div>
                                <h6 className="card-title mb-1 p-0">Custom</h6>
                                <p className="duration-card-selection card-text text-muted small mb-0">Use Tolerance Rules</p>
                            </div>
                        </div>
                    </div>

                    {/* Pannel No Constraints */}
                    <div className="col-3">
                        <div 
                            className={`card selecion-comparation ${selectedOption === 'rangeDuration' ? '' : 'opacity-50'} mb-1`}
                            style={{ 
                                border: selectedOption === 'rangeDuration' ? '2px solid #0d6efd' : '2px solid transparent',
                            }}
                            onClick={() => setSelectedOption('rangeDuration')}
                        >
                            <div className="card-body text-center p-2 d-flex flex-column justify-content-center">
                                <div className="form-check d-flex justify-content-center mb-1">
                                    <input 
                                        className="form-check-input" 
                                        type="radio" 
                                        name="constraintOption" 
                                        id="noneOption" 
                                        value="rangeDuration" 
                                        checked={selectedOption === 'rangeDuration'}
                                        onChange={(e) => setSelectedOption(e.target.value)}
                                    />
                                </div>
                                <h6 className="card-title mb-1 p-0">Range</h6>
                                <p className="duration-card-selection card-text text-muted small mb-0">Use Range in seconds</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {selectedOption === 'script' && (
                <div className="mt-2">
                    <div className='card'>
                        <div className="card-body p-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    <h5 className="mb-0">Script</h5>
                                    <small className="text-muted">Compare audio files using the Time Constraints defined in the script</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {selectedOption === 'column' && (
                <div className="mt-2">
                    <div className='card'>
                        <div className="card-body p-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    <h5 className="mb-0">Column</h5>
                                    <small className="text-muted">Use dedicated column 'Source Length' as the primary reference duration for comparison. The system will also apply additional Script TCs to refine the analysis.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Sezione 2: Regole di Tolleranza (visibile solo per Custom) */}
            {selectedOption === 'custom' && (
                <div className="mt-2 manageLengths">
                    <div className="card mb-1">
                        <div className="card-body p-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    <h5 className='mb-0'>Custom</h5>
                                    <small className='text-muted'>Set a custom threshold for the acceptable difference between the source and target audio files. You can specify this difference in either a percentage (%) or in seconds.</small>
                                </div>
                            </div>
                            <div className="row g-2 mt-2">
                                <div className="col-4">
                                    <div className="btn-group-vertical" data-bs-toggle="buttons" style={{width: '100%'}}>
                                        <button className={toleranceUnit === 'percentage' ? 'toleranceButton btn btn-sm btn-primary' : "toleranceButton btn btn-sm btn-outline-primary"} onClick={() => {setToleranceUnit('percentage'); setTolerance([-5,5])}}>Percentage</button>
                                        <button className={toleranceUnit === 'seconds' ? 'toleranceButton btn btn-sm btn-primary' : "toleranceButton btn btn-sm btn-outline-primary"} onClick={() => {setToleranceUnit('seconds'); setTolerance([-2,2])}}>Time</button>
                                    </div>
                                </div>
                                <div className="col-8 px-5">
                                    <b>Tolerance (<i className="bx bx-message-square-edit" />
                                    <EditableValue 
                                        value={tolerance[0]} 
                                        onSave={(val) => handleToleranceSave(val, 'negative')} 
                                        className='text-danger' 
                                    /> / 
                                    <EditableValue 
                                        value={tolerance[1]} 
                                        onSave={(val) => handleToleranceSave(val, 'positive')} 
                                        className='text-success' 
                                    /> 
                                    {toleranceUnit === 'percentage' ? '%' : 's'}
                                    )</b>
                                    <SliderComponent
                                        min={toleranceUnit === 'percentage' ? -50 : -30}
                                        max={toleranceUnit === 'percentage' ? 50 : 30}
                                        step={toleranceUnit === 'percentage' ? 0.5 : 0.1}
                                        limits={{
                                            enabled: true,
                                            minStart: toleranceUnit === 'percentage' ? -50 : -30,
                                            minEnd: 0,
                                            maxStart: 0,
                                            maxEnd: toleranceUnit === 'percentage' ? 50 : 30
                                        }}
                                        value={tolerance}
                                        type="Range"
                                        ticks={{
                                            placement: 'Before',
                                            largeStep: 5,
                                            smallStep: 1,
                                            showSmallTicks: true
                                        }}
                                        change={(e) => setTolerance(e.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Sezione 3: Controllo di Durata Indipendente (visibile solo per No Constraints) */}
            {selectedOption === 'rangeDuration' && (
                <div className="mt-2">
                    <div className='card'>
                        <div className="card-body p-2">
                            <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                    <h5 className="mb-0">Range</h5>
                                    <small className="text-muted">Ensure all audio files have a duration that falls within a specific minimum and maximum range. This is useful for filtering files that are either too short or too long.</small>
                                </div>
                            </div>
                            <div className="row g-2 mt-2">
                                <div className="col-4">
                                    <div className='text-muted small mt-1'>
                                        <p><br />Files with a duration outside this range will be flagged.</p>
                                    </div>
                                </div>
                                <div className="col-8 px-5">
                                    <b>Duration Range (
                                        <EditableValue 
                                            value={independentDuration[0] / 1000} 
                                            onSave={(val) => handleDurationSave(val, 'min')} 
                                            className='text-primary' 
                                        /> - 
                                        <EditableValue 
                                            value={independentDuration[1] / 1000} 
                                            onSave={(val) => handleDurationSave(val, 'max')} 
                                            className='text-primary' 
                                        />s
                                    )</b>
                                    <SliderComponent
                                        min={500}
                                        max={60000}
                                        step={100}
                                        value={independentDuration}
                                        type="Range"
                                        ticks={{
                                            placement: 'Before',
                                            largeStep: 5000,
                                            smallStep: 1000,
                                            showSmallTicks: true
                                        }}
                                        change={(e) => setIndependentDuration(e.value)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </AMModal>  }
    </>

})


// Helper component for inline editing
export const EditableValue = ({ value, onSave, className }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);
    const inputRef = useRef(null);

    useEffect(() => {
        if (isEditing) {
            inputRef.current.focus();
            inputRef.current.select();
        }
    }, [isEditing]);

    useEffect(() => {
        setCurrentValue(value); // Sync with parent state
    }, [value]);

    const handleDoubleClick = () => {
        setIsEditing(true);
    };

    const handleBlur = () => {
        onSave(currentValue);
        setIsEditing(false);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleBlur();
        } else if (e.key === 'Escape') {
            setCurrentValue(value); // Revert to original value
            setIsEditing(false);
        }
    };

    return isEditing ? (
        <input
            ref={inputRef}
            type="text"
            value={currentValue}
            onChange={(e) => setCurrentValue(e.target.value)}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            className='form-control form-control-sm d-inline-block'
            style={{ width: '60px' }}
        />
    ) : (
        <span
            onDoubleClick={handleDoubleClick}
            className={className}
            style={{ cursor: 'pointer' }}
        >
            {value}
        </span>
    );
};